import { useState, useEffect, useCallback } from 'react';
import { FamilyLookupItem } from '../types/costwand';
import { apiClient, ApiError } from '../api/apiClient.tsx';

interface UseFamilyLookupResult {
  families: FamilyLookupItem[];
  loading: boolean;
  error: string | null;
  fetchFamilies: () => Promise<void>;
}

export const useFamilyLookup = (): UseFamilyLookupResult => {
  const [families, setFamilies] = useState<FamilyLookupItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFamilies = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // Changed to use allPages: true and expect { data: T[] }
      const response = await apiClient<{ data: FamilyLookupItem[] }>('/families', { allPages: true });
      setFamilies(response.data);
    } catch (err) {
      if (err instanceof ApiError) {
        setError(`Failed to fetch families: ${err.message}`);
      } else {
        setError('An unknown error occurred while fetching families.');
      }
      setFamilies([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFamilies();
  }, [fetchFamilies]);

  return {
    families,
    loading,
    error,
    fetchFamilies,
  };
};